var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.parts),function(p,idx){return _c('span',{key:idx},[_c('span',{class:_vm.getClass(idx)},[_vm._v(_vm._s(p))]),(idx + 1 < _vm.parts.length)?_c('span',[_vm._v(" + ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }